export enum ClientViewMutationTypes {
  CLEAR_STATE = 'CLEAR_STATE',
  SET_CLIENT_DETAILS = 'SET_CLIENT_DETAILS',
  SET_CLIENT_EXISTENCE = 'SET_CLIENT_EXISTENCE',
  SET_CLIENT_LOADING = 'SET_CLIENT_LOADING',
  SET_CLIENT_ERROR = 'SET_CLIENT_ERROR',
  SET_CLIENT_FAMILY = 'SET_CLIENT_FAMILY',
  SET_PORTFOLIO = 'SET_PORTFOLIO',
  SET_PORTFOLIO_LOADING = 'SET_PORTFOLIO_LOADING',
  SET_PORTFOLIO_LIST = 'SET_PORTFOLIO_LIST',
  SET_PORTFOLIOS_LOADING = 'SET_PORTFOLIOS_LOADING',
  SET_SCENARIO = 'SET_SCENARIO',
  SET_SCENARIO_LIST = 'SET_SCENARIO_LIST',
  SET_SCENARIO_SAVING = 'SET_SCENARIO_SAVING',
  SET_SCENARIO_LOADING = 'SET_SCENARIO_LOADING',
  SET_STANDARD_FEES = 'SET_STANDARD_FEES',
}
